import React from "react";
import LoginPageLeft from "../Login/LoginPageLeft";
import StudentDetailsRight from "./StudentDetailsRight";
import { useSelector } from "react-redux";

const StudentDetails = () => {

  return (
    <div className="p-4 flex gap-10">
      <div className="md:block hidden w-1/2">
        <LoginPageLeft />
      </div>
      <div className="md:w-1/2 w-full">
        <StudentDetailsRight />
      </div>
    </div>
  );
};

export default StudentDetails;
